// extracted by mini-css-extract-plugin
export default {"cls1":"PaperAbstract-cls1_TV3","cls2":"PaperAbstract-cls2_tRC PaperAbstract-cls1_TV3"};